/* Point homepage buttons at the right pages instead of the in-page anchors
   the ported build shipped with.

   React re-renders these sections and restores its own href, so this runs on
   every observer pass - but only writes when the value differs, otherwise
   the write would trigger the observer again and loop. */
(function () {
  var LINKS = [
    { m: /light up my home/i, href: "/collections/home-lighting" },
    { m: /explore the range/i, href: "/collections/all" }
  ];

  function fix() {
    var as = document.querySelectorAll("a");
    for (var i = 0; i < as.length; i++) {
      var a = as[i];
      var t = (a.textContent || "").trim();
      if (!t) continue;
      for (var j = 0; j < LINKS.length; j++) {
        if (!LINKS[j].m.test(t)) continue;
        if (a.getAttribute("href") !== LINKS[j].href) a.setAttribute("href", LINKS[j].href);
        a.removeAttribute("target");
        break;
      }
    }
  }

  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== "loading") fix();
  else document.addEventListener("DOMContentLoaded", fix);
  window.addEventListener("load", fix);
})();

/* ------------------------------------------------------------------
   LOADER for the extra bsl-* scripts on the HOMEPAGE.
   Added 27 Sep 2026, generalised 4 Oct 2026.

   The homepage needs its own loader because templates/index.json sets
   "layout": false, so sections/bsl-home.liquid emits the whole document
   and nothing from layout/theme.liquid runs here. Piggy-backing on an
   asset the homepage already loads avoids editing that large file.

   Keep EXTRAS and VERSION in step with the copy at the foot of
   bsl-pages.js, which covers every other page.

   bsl-logomark.js, bsl-fitting.js and bsl-zoomfit.js no-op on this page.
   bsl-solar.js turns the build's lemon --color-solar into the brand orange.
   bsl-cardimg.js is homepage-critical: without it the product cards here
   keep showing images baked into the React build instead of the ones in
   Shopify admin.

   !! CACHE TRAP, AND IT HAS NOW CAUGHT ME TWICE. Editing a file in EXTRAS
   without bumping VERSION serves the old copy and the edit appears to do
   nothing. The first time cost an hour; the second was a copy change to
   bsl-sameday.js on 4 Oct that silently did not apply. If a change is not
   showing up, check VERSION here and in bsl-pages.js BEFORE assuming the
   code is wrong. Both files must carry the same VERSION.
   ------------------------------------------------------------------ */
(function () {
  var VERSION = "20261007b";
  var EXTRAS = [
    "bsl-quoteonly.js",
    "bsl-sameday.js",
    "bsl-heroword.js",
    "bsl-logomark.js",
    "bsl-solar.js",
    "bsl-fitting.js",
    "bsl-zoomfit.js",
    "bsl-cardimg.js"
  ];

  var me = document.currentScript;
  if (!me) {
    var all = document.querySelectorAll('script[src*="bsl-homecta.js"]');
    me = all[all.length - 1];
  }
  if (!me || !me.src) return;

  var dir = me.src.split("?")[0].replace(/bsl-homecta\.js$/, "");

  EXTRAS.forEach(function (file) {
    if (document.querySelector('script[src*="' + file + '"]')) return;
    var s = document.createElement("script");
    s.src = dir + file + "?v=" + VERSION;
    s.defer = true;
    (document.head || document.documentElement).appendChild(s);
  });
})();
